/**
 * Normalizes a Pokémon name and optional form to the slug used by the ComprehensiveDex / Porydex.
 * Example:
 * - "Bulbasaur" -> "bulbasaur"
 * - "Venusaur" (form: "Mega") -> "venusaurmega"
 * - "Tapu Koko" -> "tapukoko"
 * - "Mr. Mime" -> "mrmime"
 * - "Nidoran♀" -> "nidoranf"
 * - "Charizard-Mega-X" -> "charizardmegax"
 */
export function getPokemonSlug(name: string, form?: string): string {
  let combined = name;
  if (form && !combined.toLowerCase().includes(form.toLowerCase())) {
    combined = `${name} ${form}`;
  }

  return combined
    .toLowerCase()
    .replace(/♀/g, 'f')
    .replace(/♂/g, 'm')
    .replace(/é/g, 'e')
    .replace(/[^a-z0-9]/g, '');
}

/**
 * Generates a URL opening the ComprehensiveDex for the Pokémon.
 */
export function getPokemonDexUrl(name: string, form?: string): string {
  const slug = getPokemonSlug(name, form);
  return `/pokemon/${slug}`;
}

/**
 * Generates a URL opening Bulbapedia for the Pokémon.
 */
export function getBulbapediaPokemonUrl(name: string): string {
  const cleanName = name.replace(/\s*\(.*\)\s*/, '').trim().replace(/ /g, '_');
  return `https://bulbapedia.bulbagarden.net/wiki/${cleanName}_(Pok%C3%A9mon)`;
}
